import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Web3 from 'web3';

import TopNavBar from '../../Components/TopBar/Navbar';
import OZK_logo from '../../Assets/images/logo.svg';
import CustomModal from '../../Components/Modal/CustomModal';
import CustomText_input from '../../Components/Input/CustomText_input';
import GradiantButton from '../../Components/Button/GradiantButton';
import Walletaction from '../../Components/walletaction/Walletaction';
import PopUpModal from '../../Components/walletaction/PopupModal';
import ActionModal from '../../Components/Modal/ActionModal';
import AuthBtn from '../../Components/Button/AuthBtn';
import ETHLogo from '../../Assets/logos/ETHLogo.png';
import USDTLogo from '../../Assets/logos/USDTLogo.png';
import PresaleTable from './PresaleTable';
import ICOAdminWithdraw from './ICOAdminWithdraw';

import USDTABI from '../../ContractABI/USDTToken.json';

import { useAccount, useWaitForTransactionReceipt, useWriteContract } from 'wagmi';
import {
  REACT_APP_ADMIN_FUND_WITHDRAW,
  REACT_APP_ADMIN_ROLE,
  REACT_APP_ADMIN_WITHDRAW_ETH_TOPIC0,
  REACT_APP_API_KEY,
  REACT_APP_BUY_ETH_TOPIC0,
  REACT_APP_BUY_USD_TOPIC0,
  REACT_APP_CHAIN_ID,
  REACT_APP_ETH_API_URL,
  REACT_APP_FUNDS_OWNER_ROLE,
  REACT_APP_OZK_FUND,
  REACT_APP_RPC_URL,
  REACT_APP_PRIVATE_SALE,
  REACT_APP_START_BLOCK,
  REACT_APP_USDT_DECIMALS,
  REACT_APP_USDT_TOKEN,
  REACT_APP_VESTED_TOPIC0, REACT_APP_ADMIN_WHITELIST_ROLE,
} from '../../Config/Config';

import { useDepositContext } from '../../context/depositContext';
import PrivateSaleABI from '../../ContractABI/OZKPrivateSale.json';
import {getConnections} from "@wagmi/core";
import wagmiAdapterConfig from "../../Config/WagmiConfig";

const ICOAdmin = () => {
  const navigate = useNavigate();
  const [Amount, setAmount] = useState("");
  const [WithdrawModal, setWithdrawModal] = useState(false);

  const [WalletActionModal, setWalletActionModal] = useState(false);
  const [Loader1, setLoader1] = useState(false);
  const [Loader2, setLoader2] = useState(false);
  const [Loader3, setLoader3] = useState(false);
  const [WidthdrawConfirmation, setWidthdrawConfirmation] = useState(false);

  const [StartDate, setStartDate] = useState(null);
  const [EndDate, setEndDate] = useState(null);

  const [WithdrawMode, setWithdrawMode] = useState("ETH");

  const [buylisttransaction, setbuylisttransaction] = useState([])
  const [adminwithdrawtransaction, setadminwithdrawtransaction] = useState([])
 
  const [usdtToWithdraw, setUsdtToWithdraw] = useState(0)
  const [ethToWithdraw, setEthToWithdraw] = useState(0)
  const [allcotedtoken,setallcotedtoken]= useState(0)
  const [popupmodal, setpopupmodal] = useState(false)
  const [poptext, setpoptext] = useState("")
  const [Hashlink, setHashlink] = useState("");


  const { address, isConnected } = useAccount();
  const {startDate, endDate, loadDates} = useDepositContext();
  const ethweb3 = new Web3(REACT_APP_RPC_URL)
  const web3 = new Web3(REACT_APP_RPC_URL)
  const connections = getConnections(wagmiAdapterConfig);
  
  const { data: hash, error, isPending,  writeContract } = useWriteContract() 

  useEffect(()=>{
    if(error != null){
      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
    }

    if(isPending){
      setWalletActionModal(true);
      setLoader1(true);
      setLoader2(true);
      setLoader3(true);
    }
  },[error,isPending])

  const { isLoading: isConfirming, isSuccess: isConfirmed } = useWaitForTransactionReceipt({hash,})

  useEffect(()=>{
    if(isConfirmed){
      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
      getAdminWithdrawHistory()
      getTokensToWithdraw()
      fetchUsersBuyTransactions()
      loadDates();
    }
  },[isConfirming,isConfirmed])

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  const convertedTime = (unix_timestamp) => {
    const date = new Date(unix_timestamp * 1000);
    const hours = date.getHours();
    const minutes = "0" + date.getMinutes();
    const seconds = "0" + date.getSeconds();
    return date + ":" + hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2);
  };
  
  
  useEffect(() => {
    if (isConnected && address) {
      checkHasAdminOrOwnerRole(address);
      fetchUsersBuyTransactions();
      getAdminWithdrawHistory();
      getTokensToWithdraw();
    } else {
      navigate('/');
    }
  }, [isConnected, address]);
  
  const checkHasAdminOrOwnerRole = async (address) => {
    const PrivateSaleContract = new ethweb3.eth.Contract(PrivateSaleABI,REACT_APP_PRIVATE_SALE);
    const hasAdminRole = await PrivateSaleContract.methods.hasRole(REACT_APP_ADMIN_ROLE, address).call();
    const whiteListRole = await PrivateSaleContract.methods.hasRole(REACT_APP_ADMIN_WHITELIST_ROLE, address).call();
    const hasOwnerRole = await PrivateSaleContract.methods.hasRole(REACT_APP_FUNDS_OWNER_ROLE, address).call();
    if (!hasAdminRole && !hasOwnerRole && !whiteListRole) {
      navigate("/");
    }
  }

  const getTokensToWithdraw = async()=>{
    try {
        const USDTContract = new ethweb3.eth.Contract(USDTABI,REACT_APP_USDT_TOKEN)
        const availabletoken = await USDTContract.methods.balanceOf(REACT_APP_PRIVATE_SALE).call();
        console.log(availabletoken);
        const tokenavailable = parseFloat(ethweb3.utils.fromWei(Number(availabletoken), Number(REACT_APP_USDT_DECIMALS)));
        
        setUsdtToWithdraw(tokenavailable);
    } catch (e) {
      console.log("getavailablebalance error", e);
    }

    try {
      const walletBalance = await ethweb3.eth.getBalance(REACT_APP_PRIVATE_SALE);
      const ethBalance = ethweb3.utils.fromWei(walletBalance.toString(), "ether")
    
      setEthToWithdraw(Number(ethBalance));
    } catch (err) {
      console.log("Error in bnb userdetails==>", err)
    }
  }
  
  const fetchUsersBuyTransactions = async () => {
    try {
      const resultUsd = await axios.post(
        REACT_APP_RPC_URL,
        {
          jsonrpc: '2.0',
          id: 1,
          method: 'eth_getLogs',
          params: [
            {
              address: REACT_APP_PRIVATE_SALE,
              topics: [
                REACT_APP_BUY_USD_TOPIC0,
              ],
              fromBlock: web3.utils.numberToHex(REACT_APP_START_BLOCK),
              toBlock: 'latest',
            },
          ],
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      
      const resultUsdArray = resultUsd.data.result;
      
      const reversedUsdList = resultUsdArray.map((e, i, a) => a[a.length - 1 - i]);
      
      const result = await axios.post(
        REACT_APP_RPC_URL,
        {
          jsonrpc: "2.0",
          id: 1,
          method: "eth_getLogs",
          params: [
            {
              address: REACT_APP_PRIVATE_SALE,
              topics: [
                REACT_APP_BUY_ETH_TOPIC0,
              ],
              fromBlock: web3.utils.numberToHex(REACT_APP_START_BLOCK),
              toBlock: 'latest',
            },
          ],
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      const resultArray1 = result.data.result;
      const reversedList1 = resultArray1.map((e, i, a) => a[a.length - 1 - i]);
      
      const transactionHistory = [];
      const transactionHistoryamt = [];

      await Promise.all(
        reversedUsdList.map(async (event, i) => {
          const block = await ethweb3.eth.getBlock(ethweb3.utils.hexToNumber(event.blockNumber));
          const blockTime = convertedTime( Number(block.timestamp));
          const date = new Date(blockTime.slice(0, 24));
          const timeToNumber = Math.floor(date.getTime());
          
          const data1 = ethweb3.eth.abi.decodeLog(
            [
              { indexed: true, internalType: 'address', name: 'user', type: 'address' },
              { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
            ],
            event.data, // Contains non-indexed parameters
            event.topics.slice(1) // Exclude topic0 (event signature hash)
          );
          
          const userAddress = data1.user;
          const transactionHash = event.transactionHash;
          // Fetch transaction receipt
          const receipt = await ethweb3.eth.getTransactionReceipt(transactionHash);
          // Decode logs
          let tokenAmount = 0;
          const vestedEventABI = [
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
            { indexed: false, internalType: 'uint256', name: 'amountAdded', type: 'uint256' },
            { indexed: false, internalType: 'uint256', name: 'totalAmount', type: 'uint256' },
          ];

          receipt.logs.forEach((log) => {
            if (log.topics[0] === REACT_APP_VESTED_TOPIC0) {
              // Decode Vested event
              const vestedData = ethweb3.eth.abi.decodeLog(
                vestedEventABI,
                log.data,
                log.topics.slice(1) // Skip topic0 (event signature hash)
              );
              tokenAmount = ethweb3.utils.fromWei(vestedData.amountAdded, 'ether');
            }
          });
          
          const saleType1 = 'USD';
          
          const transaction = {
            transactionHash,
            useraddress: userAddress,
            usdtAmount: ethweb3.utils.fromWei(data1.amount, REACT_APP_USDT_DECIMALS),
            amount: tokenAmount,
            saleType1,
            index1: i + 1,
            date: timeToNumber,
          };
          transactionHistoryamt.push(tokenAmount);
          transactionHistory.push(transaction);
        }),
        reversedList1.map(async (event, i) => {
          const block = await ethweb3.eth.getBlock(ethweb3.utils.hexToNumber(event.blockNumber));
          const blockTime = convertedTime( Number(block.timestamp));
          const date = new Date(blockTime.slice(0, 24));
          const timeToNumber = Math.floor(date.getTime());
          
          const data1 = ethweb3.eth.abi.decodeLog(
            [
              { indexed: true, internalType: 'address', name: 'user', type: 'address' },
              { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
            ],
            event.data,
            event.topics.slice(1)
          );
          
          const userAddress = data1.user;
          
          const transactionHash = event.transactionHash;
          const receipt = await ethweb3.eth.getTransactionReceipt(transactionHash);

          let tokenAmount = 0;
          const vestedEventABI = [
            { indexed: true, internalType: 'address', name: 'user', type: 'address' },
            { indexed: false, internalType: 'uint256', name: 'amountAdded', type: 'uint256' },
            { indexed: false, internalType: 'uint256', name: 'totalAmount', type: 'uint256' },
          ];
          receipt.logs.forEach((log) => {
            if (log.topics[0] === REACT_APP_VESTED_TOPIC0) {
              const vestedData = ethweb3.eth.abi.decodeLog(
                vestedEventABI,
                log.data,
                log.topics.slice(1)
              );
              tokenAmount = ethweb3.utils.fromWei(vestedData.amountAdded, 'ether');
            }
          });
          
          const saleType1 = 'ETH';
          
          const transaction = {
            transactionHash,
            useraddress: userAddress,
            ethAmount: ethweb3.utils.fromWei(data1.amount, 'ether'),
            amount: tokenAmount,
            saleType1,
            index1: i + 1,
            date: timeToNumber,
          };
          transactionHistory.push(transaction);
          transactionHistoryamt.push(tokenAmount);
        })
      );
      
      const values = transactionHistory.sort((a, b) => b.timess - a.timess);
      
      const PrivateSaleContract = new ethweb3.eth.Contract(PrivateSaleABI,REACT_APP_PRIVATE_SALE);
      
      const vestedList = await PrivateSaleContract.methods.getVestedList().call();
      
      if (vestedList && vestedList.length > 0) {
        const totalTokenAmount = vestedList.reduce((partialSum, item) => partialSum + Number(ethweb3.utils.fromWei(item['amount'], 'ether')), 0);
        setallcotedtoken(totalTokenAmount);
      }
      
      setbuylisttransaction(values)
      
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAdminWithdrawHistory = async()=>{

    try{

      if(ethweb3 != null){

        const result = await axios.get(REACT_APP_ETH_API_URL, {
          params: {
            module: "logs",
            action: "getLogs",
            address: REACT_APP_OZK_FUND,
            topic0: REACT_APP_ADMIN_FUND_WITHDRAW,
            apikey: REACT_APP_API_KEY,
          },
        });

        const resultArray = result.data.result;
        const reversedList = resultArray.map((e, i, a) => a[a.length - 1 - i]);
        const transactionHistory = [];
        const transactionHistoryamt = [];
        await Promise.all(
          reversedList.map(async (event) => {
            const data1 = ethweb3.eth.abi.decodeLog(
              [
                { indexed: false, internalType: 'address', name: 'caller', type: 'address' },
                { indexed: false, internalType: 'address', name: 'to', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
              ],
              event.data, // Contains non-indexed parameters
              event.topics.slice(1) // Exclude topic0 (event signature hash)
            );
            
            const transactionHash = event.transactionHash;

            // const amount = parseFloat(ethweb3.utils.fromWei(data1.amount,"ether"));
            const amount =Number(data1.amount) / 1000000;
            var yourNumber = parseInt(event.timeStamp, 16) * 1000;
            var chain_type = "USDT"

            const time = String(new Date(yourNumber)).slice(4, 21);
            const timess = Number(yourNumber);
            const transaction = { transactionHash, amount, time, timess,chain_type };
            transactionHistoryamt.push(amount);
            transactionHistory.push(transaction);

          })
        );

        const result_eth = await axios.post(
          REACT_APP_RPC_URL,
          {
            jsonrpc: '2.0',
            id: 1,
            method: 'eth_getLogs',
            params: [
              {
                address: REACT_APP_PRIVATE_SALE,
                topics: [
                  REACT_APP_ADMIN_WITHDRAW_ETH_TOPIC0,
                ],
                fromBlock: web3.utils.numberToHex(REACT_APP_START_BLOCK),
                toBlock: 'latest',
              },
            ],
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        
        const resultArray_eth = result_eth.data.result;
        const reversedList_eth = resultArray_eth.map((e, i, a) => a[a.length - 1 - i]);
        const transactionHistory_bnb = [];
        
        await Promise.all(
          reversedList_eth.map(async (event) => {
            const decodeLog = ethweb3.eth.abi.decodeLog(
              [
                { indexed: false, internalType: 'address', name: 'caller', type: 'address' },
                { indexed: false, internalType: 'address', name: 'to', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
              ],
              event.data, // Contains non-indexed parameters
              event.topics.slice(1) // Exclude topic0 (event signature hash)
            );
            
            const transactionHash = event.transactionHash;
            
            const block = await ethweb3.eth.getBlock(ethweb3.utils.hexToNumber(event.blockNumber));
            const blockTime = convertedTime( Number(block.timestamp));
            const date = new Date(blockTime.slice(0, 24));
            const timeToNumber = Math.floor(date.getTime());
            
            const amount = parseFloat(ethweb3.utils.fromWei(decodeLog.amount,"ether"));
            const chainType = "ETH"
            
            const transaction = { transactionHash, amount, date: timeToNumber,chainType };
            transactionHistoryamt.push(amount);
            transactionHistory.push(transaction);

          })
        );

        setadminwithdrawtransaction([...transactionHistory,...transactionHistory_bnb])
      }

    }catch(err){
      console.log("Errorinadminwithdrawhistory==>", err)
    }
  }


  const ConfirmedWithdraw = async() => {
    const walletProvider = await connections[0].connector.getProvider();
    if (!walletProvider) {
      toast.warn('Wallet provider not found');
      return;
    }
    if (!address) {
      toast.warn('Wallet address not found');
      return;
    }
    const web3 = new Web3(walletProvider);
    setWidthdrawConfirmation(false);
    try{
      setWalletActionModal(true);
      setLoader1(false);
      setLoader2(true);
      setLoader3(true);
      const PrivateSaleContract = new web3.eth.Contract(PrivateSaleABI, REACT_APP_PRIVATE_SALE);
      if(WithdrawMode =="ETH"){
        const amount = ethweb3.utils.toWei(Amount.toString(), "ether")
        const withdraw = await PrivateSaleContract.methods.withdraw(address, amount).send({from: address})
        console.log("withdraw==>",withdraw)
      }else if(WithdrawMode =="USDT"){
        const withdrawUSDT = await PrivateSaleContract.methods.sweepTokens(REACT_APP_USDT_TOKEN, address).send({from: address})
        console.log("withdrawUSDT==>",withdrawUSDT)
      }else{
        toast.warn("Please Select ETH / USDT")
      }

      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
      setAmount("")
      getAdminWithdrawHistory()
      getTokensToWithdraw()
      fetchUsersBuyTransactions()
      IcoandvestingDates()
      getSalesDates()


    }catch(err){

      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
      setAmount("")


      console.log("Errorinclaim==>",err)
    }
   
  };

  

  const CheckinScan = () => {
    setWalletActionModal(false);
    setAmount("");
  };



  const HandleDateChange = (date) => {
    setStartDate(date);
  };

  const HandleDateChangeEndDate = (date) => {
    setEndDate(date);
  };

  const startico = async()=>{
    if (StartDate && StartDate?.$d && EndDate && StartDate?.$d) {
        const startTimestamp = new Date(StartDate?.$d).getTime() / 1000;
        const endTimestamp = new Date(EndDate?.$d).getTime() / 1000;
        if (endTimestamp > startTimestamp) {
          const ICOstart = startTimestamp.toString()
          const ICOend = endTimestamp.toString()
          try {

            setWalletActionModal(true);
            setLoader1(true);
            setLoader2(true);
            setLoader3(true);

            writeContract({
              address: REACT_APP_PRIVATE_SALE,
              abi: PrivateSaleABI,
              functionName: "setPrivateSaleDates",
              args: [ICOstart,ICOend], 
              value: 0,
            });

            setHashlink("");
            setLoader1(false);
            setLoader2(false);
            setLoader3(false);
            setWalletActionModal(false);

            setStartDate(null)
            setEndDate(null)

          } catch (err) {
            setLoader1(false);
            setLoader2(false);
            setLoader3(false);
            setWalletActionModal(false);
            setWalletActionModal(false);
            setpoptext("Something Went Wrong. Try again Later")
            setpopupmodal(true)
          }
        } else {
          setpoptext("END DATE MUST BE GREATER THAN START DATE")
          setpopupmodal(true)
          return;
        }
      } else {
        setpoptext("SELECT START & END DATE")
        setpopupmodal(true)
      }
  }
  
  const ClosePopupModal = async () => {
    setpoptext("");
    setpopupmodal(false);
  };

  const handelwithdraw = (e)=>{

    if(WithdrawMode == "ETH"){
      if(Number(ethToWithdraw) >= Number(e)){
        setAmount(e)
      }
    }
  }

  const WidthDrawConfirmation = () => {
    if(WithdrawMode == "ETH"){
      if(Number(ethToWithdraw) < Number(Amount)){
        toast.warn("ETH Balance In Contract not enough");
        return;
      }
    }
    if(WithdrawMode == "USDT"){
      if(Number(usdtToWithdraw) === 0){
        toast.warn("USDT Balance In Contract is zero");
        return;
      }
    }

    setWithdrawModal(false);
    setWidthdrawConfirmation(true);
  };

  return (
    <Grid
      container
      sm={12}
      xs={12}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"flex-start"}
      justifyContent={"center"}
      className={"saleadminBG"}
    >
      <Grid container position={"fixed"} zIndex={100}>
        <TopNavBar />
      </Grid>
      <Grid
        container
        sm={11}
        xs={12}
        display={"flex"}
        justifyContent={{ sm: "space-between", xs: "center" }}
        className={"main_position"}
      >
      
        <Grid
          container
          lg={12}
          display={"flex"}
          flexDirection={"row"}
          flexWrap={"wrap"}
          alignItems={{ sm: "stretch", xs: "center" }}
          justifyContent={{ sm: "space-between", xs: "center" }}
          className="p-3"
        >
          <Grid
            container
            lg={7.9}
            sm={7.9}
            className="saleadmin_table_layer mb-3"
            display={"flex"}
            flexDirection={"column"}
            flexWrap={"wrap"}
            alignItems={"flex-start"}
            justifyContent={"flex-start"}
          >
            <Box className="w-100">
              <PresaleTable PresaleData={buylisttransaction} 
                presaleReload={fetchUsersBuyTransactions}
              />
            </Box>
            <Box className="w-100">
              <ICOAdminWithdraw Data={adminwithdrawtransaction} 
                reloadAdminwithdraw={getAdminWithdrawHistory}
              />
            </Box>
          </Grid>
          
          <Grid container lg={3.9} sm={3.9} xs={12} className="mb-3" display={"flex"} flexDirection={"column"} flexWrap={"wrap"} alignItems={"flex-start"}>
            <Box className="w-100">
              <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                className="saleadmin_common_layer p-3"
              >
                <Grid
                  lg={12}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  className="p-3 h-100"
                >
                  <h4> Token Sold </h4>
                  <div className="d-flex alig-Items-center ">
                    
                    <h3 className="mt-2 mx-2">{formatter.format(allcotedtoken)}</h3>
                    <img src={OZK_logo} style={{width:"30px",height:"30px"}} alt="OZK_logo" className="mt-2" />
                  </div>
                  {/* <p className="mt-3" style={{ color: "rgba(124, 224, 255, 1)" }}>
                    ($ {formatter.format(allcotedtoken)} USD)
                  </p> */}
                </Grid>
              </Grid>
            </Box>

            <Box className="w-100 mt-3">
              <Grid
                item
                lg={12}
                sm={12}
                xs={12}
                className="saleadmin_common_layer p-3"
              >
                <Grid
                  lg={12}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  className="p-3 h-100"
                >
                  <h4>Available to Withdraw </h4>
                  <Grid
                    container
                    lg={11}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    className="mt-2 mb-2"
                  >
                    <Grid
                      item
                      sm={5.8}
                      xs={5.8}
                      display={"flex"}
                      flexWrap={"wrap"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      className="p-2 info_galss"
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <img
                          src={ETHLogo}
                          alt="ETH"
                          style={{ height: "20px", width: "20px" , borderRadius:"25px" }}
                        />
                        <p className="text-light  mx-2">ETH</p>
                      </Grid>
                      <p className="mt-2">{formatter.format(ethToWithdraw)}</p>
                    </Grid>
                    <Grid
                      item
                      sm={5.5}
                      xs={5.8}
                      display={"flex"}
                      flexWrap={"wrap"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      className="p-2 info_galss"
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <img
                          src={USDTLogo}
                          alt="USDT"
                          style={{ height: "20px", width: "20px" , borderRadius:"25px" }}
                        />
                        <p className="text-light mx-2">USDT</p>
                      </Grid>
                      <p className="mt-2">{formatter.format(usdtToWithdraw)}</p>
                    </Grid>
                  </Grid>
                  <GradiantButton
                    text={"WITHDRAW"}
                    width={"80%"}
                    borderColor={"#FFED8C"}
                    btnTextColor={"#FFED8C"}
                    btnColor={"#000000"}
                    className="mt-3"
                    onClick={() =>setWithdrawModal(true)}
                  />
                  
                </Grid>
              </Grid>
            </Box>
            
            
            <Box className="saleadmin_table_layer mt-3 w-100">
              <Grid
                container
                lg={12}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                className=""
              >
                <h5 className="text-center w-100 mt-3">Private Sale Schedule</h5>
                <Grid
                  container
                  lg={12}
                  display={"flex"}
                  flexDirection={"column"}
                  alignItems={"flex-start"}
                  justifyContent={"flex-start"}
                  className="px-1 py-2"
                >
                  <Grid item lg={12} className="w-100" display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} >
                    <Grid item className="" lg={6} display={"flex"} flexDirection={"column"} alignItems={"flex-start"} justifyContent={"flex-start"} >
                      <p className="mx-1 w-100">Start Date</p>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Grid className="p-2 w-100">
                          <DateTimePicker
                            sx={{
                              backgroundColor: "rgba(0, 0, 0, 0.1)",
                              borderRadius: "8px",
                              border: "1px solid #5F4C3E",
                              height: "40px",
                              color: "#ffff",
                              width: "100%",
                              outline: "none",
                              fontFamily: "PoppinsRegular",
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                color: "#FFFF",
                                borderRadius: "8px",
                                border: "none",
                                outline: "none",
                                height: "40px",
                                "&.Mui-focused fieldset": {
                                  border: "none",
                                  outline: "none",
                                },
                              },
                              placeholder: {
                                color: "#fff", // Corrected from placeholderColor
                                textTransform: "uppercase",
                              },
                              "& .MuiTypography-body1": {
                                color: "#fff",
                              },
                              "& .MuiIconButton-root": {
                                color: "#fff",
                                outline: "none",
                                border: "none",
                              },
                            }}
                            className="text-light"
                            value={StartDate}
                            onChange={(e) => HandleDateChange(e)}
                          />
                        </Grid>
                      </LocalizationProvider>
                    </Grid>
                    <Grid item className="" lg={6} display={"flex"} flexDirection={"column"} alignItems={"flex-start"} justifyContent={"flex-start"} >
                      <p className="mx-1">End Date</p>
                      
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Grid className="p-2 w-100">
                          <DateTimePicker
                            sx={{
                              backgroundColor: "rgba(0, 0, 0, 0.1)",
                              borderRadius: "8px",
                              border: "1px solid #5F4C3E",
                              height: "40px",
                              color: "#ffff",
                              width: "100%",
                              outline: "none",
                              fontFamily: "PoppinsRegular",
                              "& .MuiOutlinedInput-root": {
                                fontSize: "14px",
                                color: "#FFFF",
                                borderRadius: "8px",
                                border: "none",
                                outline: "none",
                                height: "40px",
                                "&.Mui-focused fieldset": {
                                  border: "none",
                                  outline: "none",
                                },
                              },
                              placeholder: {
                                color: "#fff", // Corrected from placeholderColor
                              },
                              "& .MuiTypography-body1": {
                                color: "#fff",
                              },
                              "& .MuiIconButton-root": {
                                color: "#fff",
                                outline: "none",
                                border: "none",
                              },
                            }}
                            className="text-light"
                            value={EndDate}
                            onChange={(e) => HandleDateChangeEndDate(e)}
                          />
                        </Grid>
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  
                  

                  { startDate && endDate && startDate !== 0 && endDate !== 0  ?
                    <p className="mt-3">Private Sale Date</p>
                    :null
                  }
                  

                  { startDate && endDate && startDate !== 0 && endDate !== 0  ?
                    <Grid lg={12} className="mt-2" container display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} >
                      <p className="mx-2">
                        {convertedTime(Number(startDate)).slice(0, 21)}
                      </p>
                      <p className="mx-2">
                        -
                      </p>
                      <p className="mx-2">
                        {convertedTime(Number(endDate)).slice(0, 21)}
                      </p>
                    </Grid>
                    :null
                  }

                  <Grid
                      container
                      lg={12}
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      className="mt-3"
                    >
                      <GradiantButton
                          text={"UPDATE SCHEDULE"}
                          width={"80%"}  
                          borderColor={"#FFED8C"}
                          btnTextColor={"#FFED8C"}
                          btnColor={"#000000"}
                          onClick={() => { startico() }}
                        />
                    </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>

        </Grid>
      </Grid>

      <CustomModal
        open={WithdrawModal}
        setOpen={setWithdrawModal}
        modalTitle={<h5>Withdraw Funds</h5>}
        width={{sm:"30%",xs:"90%"}}
        modalContent={
          <Grid
            container
            lg={12}
            xs={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"flex-start"}
          >
            <Grid
              container
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid item lg={5.8} xs={5.8} className="py-3">
                <button
                  className={`btn btn-0 border rounded  w-100 d-flex ${
                    WithdrawMode == "ETH" && "WidthDrawbtn"
                  }`}
                  style={{ alignItems: "center", justifyContent: "center" }}
                  onClick={() => setWithdrawMode("ETH")}
                >
                  <img
                    src={ETHLogo}
                    alt="ETH"
                    style={{ height: "20px", width: "20px",borderRadius:"25px" }}
                  />
                  <p className="mx-2" style={WithdrawMode == "ETH" ? {color:"#000"}:{color:"#fff"}}>ETH</p>
                </button>
              </Grid>
              <Grid item lg={5.8} xs={5.8} className="py-3">
                <button
                  className={`btn btn-0 border rounded  w-100 d-flex ${
                    WithdrawMode == "USDT" && "WidthDrawbtn"
                  }`}
                  style={{ alignItems: "center", justifyContent: "center" }}
                  onClick={() => setWithdrawMode("USDT")}
                >
                  <img
                    src={USDTLogo}
                    alt="USDT"
                    style={{ height: "20px", width: "20px" }}
                  />
                  <p className="mx-2" style={WithdrawMode == "USDT" ? {color:"#000"}:{color:"#fff"}}>USDT</p>
                </button>
              </Grid>
            </Grid>
            {WithdrawMode === "ETH" && <CustomText_input
              placeholder={"Enter Withdraw Amount"}
              isBorder={true}
              borderColor={"#fff"}
              maxLength={15}
              inputType={"number"}
              icon={
                <div
                  className="d-flex"
                  style={{ alignItems: 'center', justifyContent: 'center' }}
                >
                  <img
                    src={ETHLogo}
                    alt="ETH"
                    style={{ height: '20px', width: '20px', borderRadius: '25px' }}
                  />
                  <p className="mx-2">ETH</p>
                </div>
              }
              Value={Amount}
              HandleInput={(e) => handelwithdraw(e)}
            />}
            {/* <button
              className="btn btn-0 border-0 WidthDrawbtn w-100 p-2 text-light mt-3"
              // onClick={() => WidthDrawConfirmation()}
            >
              WITHDRAW
            </button> */}
            <AuthBtn text="WITHDRAW" width={'80%'} className="mt-3"
                     borderColor={'#FFED8C'}
              btnTextColor={"#FFED8C"}
              btnColor={"#000000"}
              onClick={() => WidthDrawConfirmation()}
            />
          </Grid>
        }
      />

      <ActionModal
        open={WidthdrawConfirmation}
        setOpen={setWidthdrawConfirmation}
        modalTitle={<h5>Sure you want to Withdraw ?</h5>}
        modalContent={
          <Grid
            container
            lg={12}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <img
              src={WithdrawMode == "ETH" ? ETHLogo : USDTLogo}
              alt="Coin"
              style={{ height: "35px", width: "35px" ,borderRadius:"25px" }}
            />
            <h3 className="mx-2 mt-2">{Amount}</h3>
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              className="mt-3"
            >
              <Grid item lg={4}>
                <AuthBtn
                  btnColor={"transparent"}
                  btnTextColor="#FFF"
                  text={"Cancel"}
                  borderColor={"#ffff"}
                  width="90%"
                  onClick={() => setWidthdrawConfirmation(false)}
                />
              </Grid>
              <div className="p-2" />
              <Grid item lg={4}>
                <GradiantButton
                  
                  text={"Confirm"}
                  
                  borderColor={"#FFED8C"}
                  btnTextColor={"#FFED8C"}
                  btnColor={"#000000"}
                  width="90%"
                  onClick={() => ConfirmedWithdraw()}
                />
              </Grid>
            </Grid>
          </Grid>
        }
      />

      <Walletaction
        WalletActionModal={WalletActionModal}
        Loader1={Loader1}
        Loader2={Loader2}
        Loader3={Loader3}
        handleClose={CheckinScan}
        isCompleted={Hashlink}
      />

      <PopUpModal
        popupmodal={popupmodal}
        poptext={poptext}
        handleClose={ClosePopupModal}
      />

    </Grid>
  );
};

export default ICOAdmin;
